var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.authorized
    ? _c("div", { staticClass: "metaSearch-content" }, [
        _c("section", { staticClass: "header" }, [
          _c("h4", {
            domProps: { textContent: _vm._s(_vm.localize("metaSearch")) },
          }),
        ]),
        _vm._v(" "),
        _c("section", { staticClass: "content" }, [
          _c("div", { staticClass: "content-row" }, [
            _vm.isLoading
              ? _c(
                  "div",
                  { staticClass: "content-row-loader" },
                  [
                    _c("b-spinner", {
                      staticStyle: { width: "3rem", height: "3rem" },
                      attrs: { label: "Large Spinner" },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "metaSearch-list" },
              [
                _c(
                  "b-list-group",
                  _vm._l(_vm.ProvidersDataSource, function (provider) {
                    return _c(
                      "b-list-group-item",
                      {
                        key: provider.searchAttributes.searchId,
                        staticClass: "metaSearch-list-item",
                        class: { activeProvider: provider.isActive },
                        on: {
                          click: function ($event) {
                            return _vm.setCurrentProvider(provider)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(provider.provider)
                        ),
                        _c("span", [
                          _vm._v(" (" + _vm._s(provider.totalCount) + ")"),
                        ]),
                      ]
                    )
                  }),
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "metaSearch-results m-4" }, [
              _c(
                "div",
                { staticClass: "meta-search" },
                [
                  _c("b-navbar-nav", [
                    _c(
                      "div",
                      { staticClass: "meta-search-bar" },
                      [
                        _c("b-form-input", {
                          staticClass: "meta-form-input form-input",
                          attrs: { placeholder: _vm.localize("metaSearch") },
                          on: {
                            keypress: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              return _vm.search.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.searchKey,
                            callback: function ($$v) {
                              _vm.searchKey = $$v
                            },
                            expression: "searchKey",
                          },
                        }),
                        _vm._v(" "),
                        _c("b-button", {
                          domProps: {
                            textContent: _vm._s(_vm.localize("search")),
                          },
                          on: {
                            click: function ($event) {
                              return _vm.search()
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _vm.activeProviderData.length > 0 && !_vm.isLoading
                ? _c(
                    "div",
                    { staticClass: "products" },
                    [
                      _vm._l(_vm.activeProviderData, function (provider) {
                        return _c(
                          "b-card",
                          {
                            key: provider.ssoReference,
                            attrs: { "no-body": "" },
                          },
                          [
                            _c(
                              "b-row",
                              { staticClass: "product-card" },
                              [
                                _c("img", {
                                  staticClass: "product-cover",
                                  attrs: {
                                    alt: "Image",
                                    src: provider.coverUrl
                                      ? provider.coverUrl
                                      : "../../assets/images/Empty_Cover.png",
                                  },
                                }),
                                _vm._v(" "),
                                _c("b-card-body", [
                                  provider.title == provider.title
                                    ? _c("h5", [
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: provider.ssoReference,
                                              target: "_blank",
                                            },
                                          },
                                          [_vm._v(_vm._s(provider.title))]
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  provider.title != provider.title
                                    ? _c("h5", [
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: provider.ssoReference,
                                              target: "_blank",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.localize("noFoundTitle")
                                              )
                                            ),
                                          ]
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  provider.authors == provider.authors[0]
                                    ? _c("h6", [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(provider.authors[0]) +
                                            "\n                                "
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  provider.authors != provider.authors[0]
                                    ? _c("h6", [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(_vm.localize("noAuthor")) +
                                            "\n                                "
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("h6", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("formatDate")(
                                          provider.publicationDate
                                        )
                                      )
                                    ),
                                  ]),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      _c("b-pagination", {
                        attrs: { "total-rows": _vm.rows, align: "fill" },
                        on: { change: _vm.handlePageChange },
                        model: {
                          value: _vm.currentPage,
                          callback: function ($$v) {
                            _vm.currentPage = $$v
                          },
                          expression: "currentPage",
                        },
                      }),
                    ],
                    2
                  )
                : _vm._e(),
            ]),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }